<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            <CRow style="width:100%">
              <CCol md="6" lg="6" xl="6"> Historial de riego </CCol>
              <CCol md="6" lg="6" xl="6">
                <CDropdown
                  class="float-right"
                  color="primary"
                  square
                  :togglerText="'Registrar riego'"
                  :split="false"
                >
                  <CDropdownItem @click="tablaRiegos = true">
                    <router-link
                      tag="li"
                      :to="{
                        name: 'NuevoRiego',
                        params: { config: { page: page, dates: selectedDate } }
                      }"
                    >
                      Registrar un riego
                    </router-link>
                  </CDropdownItem>
                  <CDropdownItem @click="tablaRiegos = false">
                    <router-link
                      tag="li"
                      :to="{
                        name: 'NuevoRiegos',
                        params: { config: { page: page, dates: selectedDate } }
                      }"
                    >
                      Registrar varias riegos
                    </router-link>
                  </CDropdownItem>
                </CDropdown>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md="6" lg="6" xl="4">
                <label class="d-block">Periodo:</label>
                <DateSelector
                  class="z-custom-2 mb-2"
                  v-model="selectedDate"
                  :date="selectedDate"
                  @input="dateSelection()"
                />
              </CCol>
            </CRow>
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="this.items"
              :fields="headersTable"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
            >
              <template #over-table>
                <CRow>
                  <CCol sm="11" col="10">
                    <CInput
                      v-model="filter"
                      @input="searchTimeOut()"
                      placeholder="Búsqueda..."
                    />
                  </CCol>
                  <CCol class="p-0" sm="1" col="2">
                    <CDropdown
                      placement="bottom-start"
                      add-menu-classes="pt-0"
                      color="primary"
                      :show.sync="dropdownCustom"
                    >
                      <template #toggler>
                        <CButton color="secondary">
                          <CIcon name="cil-settings" />
                        </CButton>
                      </template>

                      <template #default>
                        <div class="p-3 d-flex flex-column w-100">
                          <div class="mb-1">
                            <span>
                              <strong>Ver</strong>
                            </span>
                          </div>
                          <hr class="line mt-1 mb-3" />
                          <div
                            class="d-flex align-items-center justify-content-between mb-2"
                          >
                            <label class="mr-2">Cancelados:</label>
                            <CSwitch
                              @update:checked="toggleShowCancel()"
                              class="mx-1"
                              color="primary"
                              variant="3d"
                            />
                          </div>
                          <div
                            class="d-flex align-items-center justify-content-between mb-2"
                          >
                            <label class="mr-2">Autor:</label>
                            <CSwitch
                              @update:checked="toggleMostrarAutor()"
                              class="mx-1"
                              color="primary"
                              variant="3d"
                            />
                          </div>
                        </div>
                      </template>
                    </CDropdown>
                  </CCol>
                </CRow>
              </template>
              <!-- <template #loading>
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow">
                    <div class="sk-flow-dot bg-primary"></div>
                    <div class="sk-flow-dot bg-primary"></div>
                    <div class="sk-flow-dot bg-primary"></div>
                  </div>
                </div>
              </template>-->
              <template #folio-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Folio</span>
                  <OrderButtons
                    :onClick="sortField"
                    :field="'doc_riego.folio'"
                    :order="false"
                    :fila="actualSort"
                    :direcction="sorting"
                  />
                </div>
              </template>
              <template #fechahora-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Fecha</span>
                  <OrderButtons
                    :onClick="sortField"
                    :field="'doc_riego.payload->encabezado->fechahora'"
                    :order="false"
                    :fila="actualSort"
                    :direcction="sorting"
                  />
                </div>
              </template>
              <template #trabajador_id-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Trabajador</span>
                  <OrderButtons
                    :onClick="sortField"
                    :field="'trabajador.payload->nombre'"
                    :order="true"
                    :fila="actualSortJoin"
                    :direcction="sortingJoin"
                  />
                </div>
              </template>
              <template #actividad_id-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Actividad</span>
                  <OrderButtons
                    :onClick="sortField"
                    :field="'actividad.payload->nombre'"
                    :order="true"
                    :fila="actualSortJoin"
                    :direcction="sortingJoin"
                  />
                </div>
              </template>
              <template #folio="{item}">
                <td class="py-2">{{ item.folio }}</td>
              </template>
              <template #fechahora="{item}">
                <td class="py-2">
                  {{ getDate(item.payload.encabezado.fechahora) }}
                </td>
              </template>
              <template #ubicacion="{item}">
                <td class="py-2">
                  {{
                    item.payload.encabezado._relaciones.ubicacion.payload.nombre
                  }}
                </td>
                <!-- <td class="py-2">{{ item.payload.encabezado._relaciones.ubicacion_raiz.payload.nombre }}</td> -->
              </template>
              <template #cantidad_costo="{item}">
                <td class="py-2">
                  {{ item.payload.encabezado.cantidad_costo }}
                </td>
              </template>
              <template #costo_unitario="{item}">
                <td class="py-2">
                  {{ item.payload.encabezado.costo_unitario.toFixed(3) }}
                </td>
              </template>
              <template #costo_total="{item}">
                <td class="py-2">
                  {{
                    (
                      Number(item.payload.encabezado.cantidad_costo) *
                      Number(item.payload.encabezado.costo_unitario)
                    ).toFixed(3)
                  }}
                </td>
              </template>
              <template #autor-header>
                <div class="d-flex flex-row">
                  <span v-show="mostrarColumnaAutor">Autor</span>
                </div>
              </template>
              <template #autor="{item}">
                <td class="py-2">
                  <span v-show="mostrarColumnaAutor">{{
                    item.author.correo
                  }}</span>
                </td>
              </template>
              <template #entrada="{item}">
                <td class="py-2">
                  <div class="d-flex" style="gap: 10px">
                    <span>{{ item.payload.encabezado.entrada_lt }}Lt</span>
                    <span>pH: {{ item.payload.encabezado.entrada_ph }}</span>
                    <span>ce: {{ item.payload.encabezado.entrada_ce }}</span>
                  </div>
                </td>
              </template>
              <template #salida="{item}">
                <td class="py-2">
                  <div class="d-flex" style="gap: 10px">
                    <span>{{ item.payload.encabezado.salida_lt }}Lt</span>
                    <span>pH: {{ item.payload.encabezado.salida_ph }}</span>
                    <span>ce: {{ item.payload.encabezado.salida_ce }}</span>
                  </div>
                </td>
              </template>
              <template #drenado="{item}">
                <td class="py-2" style="gap: 10px">
                  <span
                    >{{
                      $formatter(
                        (item.payload.encabezado.salida_lt /
                          item.payload.encabezado.entrada_lt) *
                          100
                      )
                    }}%</span
                  >
                </td>
              </template>
              <template #ver="{item}">
                <td class="py-2">
                  <router-link
                    :to="{
                      name: 'VerRiego',
                      params: {
                        id: item.folio,
                        config: { page: page, dates: selectedDate }
                      }
                    }"
                  >
                    <CButton color="success" square size="sm">Ver</CButton>
                  </router-link>
                </td>
              </template>
              <template #reporte="{item, index}">
                <td class="py-2">
                  <CButton
                    color="info"
                    square
                    size="sm"
                    @click="getReporte(index, item)"
                  >
                    <i v-if="loader[index]" class="fa fa-spinner fa-pulse"></i>
                    <template v-else>PDF</template>
                  </CButton>
                </td>
              </template>
              <template #cancel="{item, index}">
                <td class="py-2">
                  <CButton
                    color="danger"
                    square
                    size="sm"
                    @click="toggleCancel(index, item)"
                    >Cancelar</CButton
                  >
                </td>
              </template>
              <template #under-table>
                <CPagination
                  :activePage.sync="page"
                  :pages="pages"
                  align="center"
                  @update:activePage="e => actualizarInfo(e)"
                />
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Cancelar"
      color="danger"
    >
      <h5 class="text-center">
        ¿Deseas cancelar la labor con folio {{ this.itemModal.name }}?
      </h5>
      <template #header>
        <h5 class="modal-title">Cancelar Labor</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton
          @click="cancelDocto(itemModal.index, itemModal.id)"
          color="success"
          >Aceptar</CButton
        >
      </template>
    </CModal>

    <ModalTable :datasheet="pagosDias" :show="showTablePagosDias" />

    <CModal
      size="sm"
      title="Reporte"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
      >{{ error }}</CModal
    >
  </div>
</template>

<script>
import moment from "moment";
import DateSelector from "../../../customComponents/DateSelector";
import ModalTable from "../../../customComponents/ModalTable";

import OrderButtons from "../../../customComponents/OrderButtons";
import GridAutorMixin from "../../../mixins/GridAutor";

const fields = [
  {
    key: "folio",
    label: "Folio",
    _style: "width:10%"
  },
  // { key: "UBICACION_NOMBRE", label: "Ubicación", _style: "width:10%" },
  {
    key: "fechahora",
    label: "Fecha",
    _style: "width:10%"
  },
  {
    key: "ubicacion",
    label: "Ubicación",
    _style: "width:25%"
  },
  {
    key: "entrada",
    label: "Entrada",
    _style: "width:25%"
  },
  {
    key: "salida",
    label: "Salida",
    _style: "width:25%"
  },
  {
    key: "drenado",
    label: "Drenado",
    _style: "width:25%"
  },
  {
    key: "autor",
    label: "",
    _style: "width:1%"
  },
  {
    key: "ver",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "reporte",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Labor",
  components: {

    DateSelector,
    ModalTable,
    OrderButtons
  },
  mixins: [GridAutorMixin],
  data() {
    return {
      tablaRiegos: false,
      items: [],
      fields,
      warningModal: false,
      error: "",
      config: this.$route.params.config,
      dropdownCustom: false,
      showCancel: false,
      isLoteActive: true,
      isCreated: false,
      color1: "primary",
      color2: "secondary",
      filter: "",
      noItems: {
        noResults: "Sin Resultados",
        noItems: "Sin Resultados"
      },
      ubicaciones: [],
      actualSort: "doc_riego.payload->encabezado->fechahora",
      actualSortJoin: "",
      cambioUbicacionRaiz: false,
      // ubicacionesAll: [],
      // cultivos: [],
      // cultivosAll: [],
      // lotes: [],
      showPagosDias: false,
      trabajadores: [],
      actividades: [],
      empresa: "",
      trabajador: "",
      empresas: [],
      pagosDias: [],
      showTablePagosDias: false,

      // cultivo: null,
      // ubicacion: null,
      // lote: null,
      fechaCalcularPD: false,
      fechaCalcularPagoDias: {
        start: moment()
          .startOf("month")
          .toDate(),

        end: moment()
          .endOf("month")
          .toDate()
      },

      showUbicaciones: false,
      itemModal: {
        id: "",
        name: "",
        index: ""
      },

      cancelModal: false,
      isLoading: false,
      alertError: false,
      message: "",
      page: 1,
      pages: 1,
      sorting: "desc",
      sortingJoin: "",
      selectedDate: {
        start: moment()
          .startOf("month")
          .toDate(),

        end: moment()
          .endOf("month")
          .toDate()
      },
      loader: {}
    };
  },

  created() {
    if (this.ubicacionRaiz == "") {
      this.items = [];
      return;
    }

    this.isCreated = false;

    this.page = this.config ? this.config.page : 1;
    this.selectedDate = this.config ? this.config.dates : this.selectedDate;
    this.actualizarInfo();
  },

  computed: {
    rangeStart() {
      return new Date(this.selectedDate.start).toLocaleDateString();
    },
    rangeEnd() {
      return new Date(this.selectedDate.end).toLocaleDateString();
    },
    headersTable() {
      return this.fields;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    items(newV, ) {
      this.loader = newV.reduce((v, c, i) => ({ ...v, [i]: false }), {});
    },
    ubicacionRaiz: function() {
      this.page = 1;
      if (this.ubicacionRaiz == "") {
        this.items = [];
        return;
      }
      this.cambioUbicacionRaiz = true;
      this.actualizarInfo();
    }
  },

  methods: {
    getReporte(index, item) {
      if (this.loader[index]) {
        return;
      }
      this.loader[index] = true;
      this.$forceUpdate();
      const reportCall = {
        reporte: "formato_riego",
        params: { folio: item.folio, ubicaciones: [this.ubicacionRaiz] },
        pdf: true
      };

      // console.log(reportCall);
      // call.push(reportCall);

      this.$store
        .dispatch("reportsPDFHttp", {
          ...reportCall
        })
        .then(res => {
          const blob = res;

          let a = document.createElement("a");
          a.style = "display: none";
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "Reporte de riego.pdf";
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.loader[index] = false;
          this.$forceUpdate();
        });
    },
    validarTrabajador(trabajador) {
      if (trabajador._relaciones.trabajador != null) {
        return trabajador._relaciones.trabajador.payload.nombre;
      }
      // else{
      //   const trabajadorActual = this.trabajadores.filter(
      //     trabajador => trabajador.id == trabajador.trabajador_id
      //   );
      //   if (trabajadorActual.length > 0) {
      //     // return trabajadorActual[0].payload.nombre;
      //     return trabajadorActual[0].label
      //   } else {
      //     return "";
      //   }
      // }
    },
    validarActividad(actividad) {
      if (actividad._relaciones.actividad != null) {
        return actividad._relaciones.actividad.payload.nombre;
      }
    },
    validarUbicaciones(ubicaciones) {
      if (ubicaciones._relaciones.ubicacion != null) {
        var ubicacionesAll = "";
        Object.values(ubicaciones._relaciones.ubicacion).forEach(ubicacion => {
          ubicacionesAll += ubicacion.payload.nombre + ", ";
        });
        return ubicacionesAll;
      }
    },
    closeDropdown() {
      this.dropdownCustom = false;
    },
    searchTimeOut() {
      if (this.isCreated) {
        this.showTablePagosDias = false;
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          this.actualizarInfo();
        }, 800);
      }
    },
    toggleUbicaciones() {
      this.showUbicaciones = !this.showUbicaciones;
    },
    toggleShowCancel() {
      this.showCancel = !this.showCancel;
      this.actualizarInfo();
    },
    sortField(field, direction, join) {
      if (join) {
        this.actualSort = "";
        this.sorting = "";
        this.actualSortJoin = field;
        this.sortingJoin = direction;
      } else {
        this.actualSort = field;
        this.sorting = direction;
        this.actualSortJoin = "";
        this.sortingJoin = "";
      }
      this.actualizarInfo();
    },
    dateSelection() {
      if (this.isCreated) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          this.actualizarInfo();
        }, 800);
      }
    },
    getDate(date) {

      return moment(date,'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    toggleEdit(index, item) {
      this.modal = true;
      const itemIndex = {
        id: index,
        name: item.cultivo
      };
      this.itemModal = itemIndex;
    },
    toggleCancel(index, item) {
      this.showTablePagosDias = false;
      this.cancelModal = true;
      const itemIndex = {
        id: item.folio,
        name: item.folio,
        index: index
      };
      this.itemModal = itemIndex;
      console.log(this.showTablePagosDias);
    },
    cancelDocto(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customDocumentoCancelHTTP", {
          schema: "riego",
          folio: id
        })
        .then(() => {
          this.actualizarInfo();
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          this.cancelModal = false;
        });
    },
    handlePagosDias() {
      this.showTablePagosDias = false;
      this.showPagosDias = true;
    },

    actualizarInfo() {
      if (this.ubicacionRaiz == "") {
        this.items = [];
        return;
      }

      this.isLoading = true;
      let template = {
        schema: "riego",
        limit: 50,
        page: this.page,
        filter: {
          wherein: [
            {
              field: "doc_riego.payload->encabezado->ubicacion_raiz_id",
              value: [this.ubicacionRaiz]
            }
          ],
          where: [
            {
              field: "doc_riego.payload->encabezado->fechahora",
              operator: ">=",
              value: moment(this.selectedDate.start).format(
                "YYYY-MM-DD 00:00:00"
              )
            },
            {
              field: "doc_riego.payload->encabezado->fechahora",
              operator: "<=",
              value: moment(this.selectedDate.end).format("YYYY-MM-DD 23:59:59")
            }
          ]
        },
        ["with-storage"]: ["*"]
      };

      this.actualSort != ""
        ? (template = {
            ...template,
            order: [
              {
                field: this.actualSort,
                direction: this.sorting
              }
            ]
          })
        : null;

      this.actualSortJoin != ""
        ? (template = {
            ...template,
            orderByJoin: [
              {
                field: this.actualSortJoin,
                direction: this.sortingJoin
              }
            ]
          })
        : null;

      this.filter != ""
        ? (template = {
            ...template,
            filter: {
              ...template.filter,
              and: {
                orWhere: [
                  {
                    field: "doc_riego.folio",
                    operator: "like",
                    value: `%${this.filter}%`,
                    collate: "utf8mb4_unicode_ci"
                  },
                  {
                    field: "doc_riego.payload->encabezado->entrada_ce",
                    operator: "like",
                    value: `%${this.filter}%`,
                    collate: "utf8mb4_unicode_ci"
                  },
                  {
                    field: "doc_riego.payload->encabezado->entrada_lt",
                    operator: "like",
                    value: `%${this.filter}%`,
                    collate: "utf8mb4_unicode_ci"
                  },
                  {
                    field: "doc_riego.payload->encabezado->entrada_ph",
                    operator: "like",
                    value: `%${this.filter}%`,
                    collate: "utf8mb4_unicode_ci"
                  },
                  {
                    field: "doc_riego.payload->encabezado->salida_ce",
                    operator: "like",
                    value: `%${this.filter}%`,
                    collate: "utf8mb4_unicode_ci"
                  },
                  {
                    field: "doc_riego.payload->encabezado->salida_lt",
                    operator: "like",
                    value: `%${this.filter}%`,
                    collate: "utf8mb4_unicode_ci"
                  },
                  {
                    field: "doc_riego.payload->encabezado->salida_ph",
                    operator: "like",
                    value: `%${this.filter}%`,
                    collate: "utf8mb4_unicode_ci"
                  },
                  ...(this.mostrarColumnaAutor
                    ? [
                        {
                          field: "doc_riego.author->correo",
                          operator: "like",
                          value: `%${this.filter}%`,
                          collate: "utf8mb4_unicode_ci"
                        }
                      ]
                    : [])
                ],
                orWhereJoin: [
                  {
                    field: "ubicacion.payload->nombre",
                    operator: "like",
                    value: `%${this.filter}%`,
                    collate: "utf8mb4_unicode_ci"
                  }
                ]
              }
            }
          })
        : null;

      !this.showCancel
        ? (template = {
            ...template,
            filter: {
              ...template.filter,
              where: [
                ...template.filter.where,
                {
                  field: "doc_riego.estado",
                  operator: "!=",
                  value: "cancelado"
                }
              ]
            }
          })
        : null;

      const documento = [this.$store.dispatch("customDocumentoHTTP", template)];
      if (!this.isCreated || this.cambioUbicacionRaiz) {
        this.cambioUbicacionRaiz = false;
        documento.push(
          this.$store.dispatch("customHTTP", { schema: "empresas" })
        );
        documento.push(
          this.$store.dispatch("customHTTP", {
            schema: "trabajadores",
            filter: {
              where: [
                {
                  field: "payload->ubicaciones",
                  operator: "regexp",
                  value: `[[:<:]]${this.ubicacionRaiz}[[:>:]]`
                },
                {
                  field: "payload->suspendido",
                  operator: "=",
                  value: false
                }
              ]
            }
          })
        );
      }

      Promise.all(documento)
        .then(([documentos, empresas, trabajadores]) => {
          this.items = documentos.data;
          this.pages = documentos?.paginate?.last_page;
          this.page = documentos?.paginate?.current_page;
          this.empresas = empresas.data.map(empresa => {
            return {
              value: empresa.id,
              label: empresa.payload.nombre
            };
          });
          this.trabajadores = trabajadores.data.map(trabajador => {
            return {
              value: trabajador.id,
              label: trabajador.payload.nombre
            };
          });

          this.isCreated = true;
        })
        .catch(error => {
          console.log(error.message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.line {
  width: 100%;
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.z-custom {
  z-index: 1;
}
.z-custom-2 {
  z-index: 4;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}

.custom-width-btn {
  width: 40%;
}
.custom-heigth-btn {
  width: 100%;
}
.custom-font-size {
  font-size: 1rem;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
